export default __webpack_public_path__ + "static/media/tie_5.a3f97517.mp3";